import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { DocumentDownloadDialogComponent } from '../../components/document-download-dialog/document-download-dialog.component';
import { SettingsService } from "src/app/modules/settings/settings.service";
/**
 * Script start
 */
var PropertyDetailMappingRemakeDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyDetailMappingRemakeDialogComponent(dialogRef, data, dialog, configService, translateService, authService, cookieService, settingsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.configService = configService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.dialogIsLoading = false; // Used to view/hide form loading spinner
        this.noDocs = false;
        this.docs = [];
        this.propertyId = "";
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyDetailMappingRemakeDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        if (this.data) {
            if (typeof this.data.docs !== "undefined" && typeof this.data.docs.documents !== "undefined") {
                var obj_1 = this.data.docs.documents;
                this.propertyId = this.data.propertyId;
                this.subscriptions.push(this.settingsService.getDocument().subscribe(function (res) {
                    var e_1, _a, e_2, _b, e_3, _c;
                    var translationMap = {};
                    if (res.status &&
                        res.data &&
                        Array.isArray(res.data) &&
                        res.data.length > 0 &&
                        res.data[0].area &&
                        Array.isArray(res.data[0].area)) {
                        try {
                            // Ciclo le aree del template documenti per costruire la mappa key -> { it, en }
                            for (var _d = tslib_1.__values(res.data[0].area), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var area = _e.value;
                                if (area && area.content && Array.isArray(area.content)) {
                                    try {
                                        for (var _f = (e_2 = void 0, tslib_1.__values(area.content)), _g = _f.next(); !_g.done; _g = _f.next()) {
                                            var contentItem = _g.value;
                                            if (contentItem && contentItem.key && contentItem.translation) {
                                                translationMap[contentItem.key] = {
                                                    it: contentItem.translation.it,
                                                    en: contentItem.translation.en,
                                                };
                                            }
                                            // Le key dei singoli documenti (es. AC1, AC2, ...) stanno in contentItem.documents
                                            if (contentItem && contentItem.documents && Array.isArray(contentItem.documents)) {
                                                try {
                                                    for (var _h = (e_3 = void 0, tslib_1.__values(contentItem.documents)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                                        var docItem = _j.value;
                                                        if (docItem && docItem.key && docItem.translation) {
                                                            translationMap[docItem.key] = {
                                                                it: docItem.translation.it,
                                                                en: docItem.translation.en,
                                                            };
                                                        }
                                                    }
                                                }
                                                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                                finally {
                                                    try {
                                                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                                                    }
                                                    finally { if (e_3) throw e_3.error; }
                                                }
                                            }
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    var _loop_1 = function (key) {
                        if (Array.isArray(obj_1[key]) && obj_1[key].length) {
                            obj_1[key].forEach(function (el) {
                                if (el.data) {
                                    _this.noDocs = true;
                                    var translation = translationMap[key];
                                    var title = translation
                                        && (_this.lang === "it" ? translation.it : translation.en);
                                    _this.docs.push({
                                        title: title,
                                        key: key,
                                        subDocId: el._id,
                                        content: el.data.contenutoDocumento,
                                        docDate: el.data.dataDocumento,
                                        value: false,
                                        document: el.data.document,
                                    });
                                }
                            });
                        }
                    };
                    for (var key in obj_1) {
                        _loop_1(key);
                    }
                }, function (err) {
                    console.error("Errore nel caricamento del template documenti:", err);
                }));
            }
        }
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyDetailMappingRemakeDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle dialog confirmation
     *
     * @since 1.0.0
     */
    PropertyDetailMappingRemakeDialogComponent.prototype.onConfirmation = function (data) {
        var docs = this.docs.filter(function (el) {
            return el.value;
        });
        this.dialogRef.close(docs);
    };
    /**
     * Handle dialog denial
     *
     * @since 1.0.0
     */
    PropertyDetailMappingRemakeDialogComponent.prototype.onDenial = function (data) {
        this.dialogRef.close();
    };
    /**
   * Handle click on document form to download file
   * itemData: data value of form items
   *
   * @since 1.0.0
   */
    PropertyDetailMappingRemakeDialogComponent.prototype.onToggleDownloadDocument = function (documents) {
        if (!documents || !documents.length) {
            console.warn("ERROR: NO DOCS");
            return;
        }
        this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                propertyId: this.propertyId,
                documents: documents,
            },
            width: "600px"
        });
    };
    return PropertyDetailMappingRemakeDialogComponent;
}());
export { PropertyDetailMappingRemakeDialogComponent };
